import { render, staticRenderFns } from "./testimg.vue?vue&type=template&id=3378abd7&"
import script from "./testimg.vue?vue&type=script&lang=js&"
export * from "./testimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports